import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20inspiring%20sports%20atmosphere%20with%20soft%20golden%20sunset%20light%2C%20abstract%20motion%20blur%20of%20runners%20and%20athletes%2C%20warm%20orange%20and%20coral%20tones%2C%20motivational%20and%20energetic%20mood%2C%20cinematic%20gradient%20style&width=1800&height=600&seq=cta-yunkai-sports&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-800/85 via-primary-700/75 to-primary-600/80"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-4">
          准备好开始您的运动之旅了吗？
        </h2>
        <p className="text-background-50/80 text-lg mb-8 max-w-xl mx-auto">
          加入云开体育，与50,000多名运动爱好者一起，享受专业、便捷、高品质的体育服务体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/membership"
            className="px-8 py-3.5 rounded-full bg-accent-500 text-background-50 font-semibold text-base whitespace-nowrap cursor-pointer hover:bg-accent-600 transition-all hover:scale-105"
          >
            立即加入会员
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full border-2 border-background-50/50 text-background-50 font-semibold text-base whitespace-nowrap cursor-pointer hover:bg-background-50/15 transition-all"
          >
            联系我们
          </Link>
        </div>
      </div>
    </section>
  );
}